import React from 'react';
import css from './FiltersBadge.css';
import { FieldCheckbox, FilterPopup } from '../../components';
import { IconFilter } from '../../icons';
import config from '../../config';

const { userTypeHorseowner, userTypeRider } = config;

const defaultOptions = [
    {
        key: 'country',
        value: 'CH',
        label: 'Schweiz',
    },
    {
        key: 'country',
        value: 'DE',
        label: 'Deutschland',
    },
    {
        key: 'userType',
        value: userTypeRider,
        label: 'Reiter:innen',
    },
    {
        key: 'userType',
        value: userTypeHorseowner,
        label: 'Pferdebesitzer:innen',
    },
    {
        key: 'userType',
        value: 'administrator',
        label: 'Admin',
    },
];

export const FiltersBadge = ({
    initialValues = {},
    options = defaultOptions,
    handleOptionUpdate,
    optionsSelected,
}) => {
    return (
        <FilterPopup
            isSelected={optionsSelected > 0}
            labelClassName={css.label}
            className={css.root}
            options={options}
            onSubmit={(_, values) => handleOptionUpdate(values)}
            initialValues={initialValues}
            label={
                <>
                    <IconFilter />
                    <span>Filter</span>
                    {optionsSelected ? <span> · {optionsSelected}</span> : null}
                </>
            }
        >
            {options.map((option, index) => (
                <FieldCheckbox
                    key={option.key + index}
                    id={option.value}
                    name={option.key}
                    label={option.label}
                    value={option.value}
                    className={css.checkbox}
                />
            ))}
        </FilterPopup>
    );
};
